export const ua = {
  // ── Навігація ────────────────────────────────────────
  "nav.dashboard":       "Дашборд",
  "nav.devices":         "Пристрої",
  "nav.zones":           "Зони",
  "nav.companies":       "Компанії",
  "nav.schedule":        "Розклад",
  "nav.templates":       "Шаблони",
  "nav.log":             "Лог",
  "nav.settings":        "Налаштування",
  "nav.section.main":    "Головне",
  "nav.section.content": "Контент",
  "nav.section.admin":   "Адмін",

  // ── Топбар ───────────────────────────────────────────
  "topbar.addSchedule": "Додати розклад",
  "topbar.logout":      "Вийти",
  "topbar.theme":       "Змінити тему",

  // ── Користувач ───────────────────────────────────────
  "user.admin":    "Адміністратор",
  "user.operator": "Оператор",

  // ── Статус пристрою ──────────────────────────────────
  "status.master":  "Мастер",
  "status.client":  "Клієнт",
  "status.offline": "Офлайн",
  // Legacy (сумісність)
  "status.online":  "Клієнт",
  "status.server":  "Мастер",

  // ── Сторінка пристроїв ───────────────────────────────
  "devices.title":        "Пристрої",
  "devices.search":       "Пошук за ID або компанією…",
  "devices.allCompanies": "Всі компанії",
  "devices.allStatuses":  "Всі статуси",
  "devices.hideOffline":  "Сховати офлайн",
  "devices.showOffline":  "Показати всі",
  "devices.total":        "Всього",
  "devices.online":       "Онлайн",
  "devices.offline":      "Офлайн",
  "devices.commands":     "Команди",
  "devices.nowPlaying":   "Відтворення",
  "devices.lastSeen":     "Останній онлайн",
  "devices.command":      "Команда",
  "devices.actions":      "Дії",
  "devices.zone":         "Зона",
  "devices.group":        "Компанія",
  "devices.rackName":     "Назва стійки",
  "devices.files":        "Файли",
  "devices.startSelected": "Запустити вибрані",
  "devices.stopSelected":  "Зупинити вибрані",
  "devices.updateSelected": "Оновити відео",
  "devices.deleteVideo":    "Видалити відео",
  "devices.viewTable":      "Таблиця",
  "devices.viewCards":      "Картки",
  "devices.viewGroups":     "Компанії",

  // ── Команди пристроїв ────────────────────────────────
  "cmd.play":          "Запустити",
  "cmd.stop":          "Зупинити",
  "cmd.startall":      "Запустити всі",
  "cmd.stopall":       "Зупинити всі",
  "cmd.updatevideo":   "Оновити відео",
  "cmd.deletevideo":   "Видалити відео",
  "cmd.activate":      "Активувати",
  "cmd.appclose":      "Закрити додаток",
  "cmd.upd_playlist":  "Оновити плейліст",
  "cmd.upd_settings":  "Оновити налаштування",

  // ── Сторінка зон ─────────────────────────────────────
  "zones.title":         "Зони",
  "zones.create":        "Нова зона",
  "zones.onlineOnly":    "Тільки онлайн",
  "zones.showAll":       "Показати всі",
  "zones.totalZones":    "Всього зон",
  "zones.onlineDevices": "Онлайн пристроїв",
  "zones.synced":        "Синхронізовано",
  "zones.diffFiles":     "Різні файли",
  "zones.filesMatch":    "✓ Файли однакові",
  "zones.filesDiff":     "⚠ Різні файли",
  "zones.allOffline":    "Всі офлайн",
  "zones.noDevices":     "Немає пристроїв",
  "zones.addDevice":     "Додати пристрій",
  "zones.backToZones":   "← Назад",
  "zones.manageDevices": "Управління пристроями",

  // ── Сторінка розкладу ────────────────────────────────
  "schedule.title":       "Розклад",
  "schedule.add":         "+ Додати розклад",
  "schedule.allTasks":    "Всі завдання",
  "schedule.newTask":     "+ Нове завдання",
  "schedule.month":       "Місяць",
  "schedule.week":        "Тиждень",
  "schedule.today":       "Сьогодні",
  "schedule.zone":        "Зона",
  "schedule.allZones":    "Всі зони",
  "schedule.playlist":    "Плейліст (файли через кому)",
  "schedule.time":        "Час запуску",
  "schedule.days":        "Дні тижня",
  "schedule.advance":     "Відправити за N хвилин до",
  "schedule.workdays":    "Будні",
  "schedule.weekends":    "Вихідні",
  "schedule.all":         "Всі",
  "schedule.active":      "Активне",
  "schedule.disabled":    "Вимкнено",
  "schedule.files":       "Файли",
  "schedule.recurrence":  "Повторення",
  "schedule.name":        "Назва завдання",
  "schedule.step1":       "Налаштування",
  "schedule.step2":       "Плейліст",
  "schedule.step3":       "Перевірка",

  // ── Компанії (адмін) ─────────────────────────────────
  "companies.title":  "Компанії",
  "companies.create": "Створити компанію",

  // ── Сторінка налаштувань ─────────────────────────────
  "settings.users":       "Користувачі",
  "settings.account":     "Мій акаунт",
  "settings.newPassword": "Новий пароль",
  "settings.login":       "Логін",
  "settings.email":       "Email",
  "settings.password":    "Пароль",
  "settings.company":     "Компанія",

  // ── Дашборд ──────────────────────────────────────────
  "dashboard.activity":       "Активність пристроїв",
  "dashboard.todaySchedule":  "Розклад сьогодні",
  "dashboard.quickActions":   "Швидкі дії",
  "dashboard.allCompanies":   "Всі компанії",
  "dashboard.live":           "live",
  "dashboard.details":        "Детальніше",
  "dashboard.noEvents":       "Немає подій",
  "dashboard.emptySchedule":  "Розклад порожній",
  "dashboard.play":           "Запустити",
  "dashboard.stop":           "Зупинити",
  "dashboard.updateVideo":    "Оновити відео",
  "dashboard.companies":      "компаній",
  "dashboard.statusOffline":  "офлайн",
  "dashboard.statusRunning":  "виконує команду",
  "dashboard.statusOnline":   "підключився",
  "nav.groups":               "Компанії",

  // ── Нова платформа екранів ───────────────────────────
  "nav.screens":              "Екрани",
  "nav.old":                  "Стара платформа",
  "nav.section.newplatform":  "Нова платформа",
  "screens.title":            "Екрани",
  "screens.addScreen":        "Додати екран",
  "screens.deviceId":         "ID пристрою",
  "screens.displayName":      "Назва",
  "screens.status":           "Статус",
  "screens.lastSeen":         "Останній онлайн",
  "screens.appVersion":       "Версія APK",
  "screens.actions":          "Дії",
  "screens.online":           "Онлайн",
  "screens.offline":          "Офлайн",
  "screens.activateTitle":    "Активувати новий екран",
  "screens.activateDesc":     "Введіть 9-значний код, що відображається на екрані ТВ",
  "screens.codeLabel":        "Код активації",
  "screens.activateBtn":      "Активувати",
  "screens.noScreens":        "Екранів ще немає. Активуйте перший пристрій.",
  "screens.never":            "Ніколи",
  "screens.detail.title":     "Деталі екрану",
  "screens.detail.info":      "Інформація",
  "screens.detail.ip":        "IP-адреса",
  "screens.detail.since":     "Додано",
  "screens.detail.configVer": "Версія конфігурації",
  "screens.detail.tabSettings":    "Налаштування",
  "screens.detail.tabScreenshot":  "Скріншот",
  "screens.detail.content":        "Налаштування контенту",
  "screens.detail.defaultContent": "Контент за замовчуванням",
  "screens.detail.scheduledContent": "Розклад контенту",
  "screens.detail.contentPlaylist": "Плейліст",
  "screens.detail.contentMedia":   "Медіафайл",
  "screens.detail.contentOff":     "Вимкнено",
  "screens.detail.noSchedule":     "Без розкладу",
  "screens.detail.chooseFile":     "Обрати файл…",
  "screens.detail.scale":          "Масштаб",
  "screens.detail.scaleFill":      "Заповнити",
  "screens.detail.scaleFit":       "Вмістити",
  "screens.detail.scaleStretch":   "Розтягнути",
  "screens.detail.selectedFile":   "Обраний файл",
  "screens.detail.noPlaylists":    "Немає плейлістів",
  "screens.detail.tabMedia":       "Медіа",
  "screens.detail.tabLogs":        "Логи",
  "screens.detail.savePublish":    "Зберегти та опублікувати",
  "screens.detail.publishing":     "Публікація…",
  "screens.detail.published":      "Опубліковано",
  "screens.detail.publishFailed":  "Помилка",
  "screens.detail.debugMode":          "Режим відлагодження",
  "screens.detail.debugModeHint":      "Показувати накладку на пристрої з інформацією про синхронізацію та відтворення",
  "screens.detail.crashLogEnabled":    "Надсилати звіти про збої",
  "screens.detail.crashLogEnabledHint":"Дозволити пристрою надсилати логи збоїв на сервер",
  "screens.detail.kioskMode":          "Режим кіоску",
  "screens.detail.kioskModeHint":      "Закріпити додаток на екрані — заборонити вихід",
  "screens.detail.autostart":               "Автозапуск при вмиканні",
  "screens.detail.autostartHint":           "Запускати застосунок автоматично після ввімкнення приставки",
  "screens.detail.disableStandby":     "Вимкнути режим очікування",
  "screens.detail.disableStandbyHint": "Тримати екран завжди увімкненим, вимкнути таймаут сну",
  "screens.detail.screenOrientation":       "Орієнтація екрана",
  "screens.detail.screenOrientationHint":   "Повертає весь застосунок разом із налаштуваннями",
  "screens.detail.contentRotation":         "Поворот контенту",
  "screens.detail.contentRotationHint":     "Повертає лише контент — коли панель висить боком",
  "screens.detail.tabCommands":    "Команди",
  "screens.cacheTtlDays":            "TTL кешу (дні)",
  "screens.cacheTtlHint":            "Видаляти невикористовувані файли з пристрою через N днів. 0 = зберігати завжди.",
  "screens.cacheTtlForever":         "Зберігати завжди",
  "screens.cacheTtlDaysUnit":        "днів",
  "screens.offlineTimeoutDays":      "Блокування офлайн (дні)",
  "screens.offlineTimeoutHint":      "Зупинити відтворення якщо пристрій не підключався до сервера N днів. 0 = без обмежень.",
  "screens.offlineTimeoutUnlimited": "Без обмежень",
  "screens.cachedFiles":           "Файли на пристрої",
  "screens.cachedFilesCount":      "файлів",
  "screens.clearCache":            "Очистити все",
  "screens.deleteUnused":          "Видалити невикористовувані",
  "screens.cmdSent":               "Команду відправлено — пристрій застосує протягом 30 сек",
  "screens.cmdQueue":              "Черга команд",
  "screens.noPendingCmds":        "Немає команд в очереді",
  "screens.noCachedFiles":         "На пристрої немає кешованих файлів",
  "screens.bitDepthWarnTitle":     "Виявлено 10-бітне відео",
  "screens.bitDepthWarnDesc":      "Наступні файли мають 10-бітну глибину кольору та можуть не відтворюватись на Android-пристроях:",
  "screens.bitDepthConvertDesc":   "Конвертувати у 8-біт (H.264/yuv420p) для сумісності з усіма пристроями. Оригінальні файли будуть замінені.",
  "screens.bitDepthConvert":       "Конвертувати у 8-біт",
  "screens.bitDepthConverting":    "Конвертація… це може зайняти кілька хвилин",
  "screens.bitDepthPublishAnyway": "Все одно опублікувати",
  "screens.deviceControl":  "Управління пристроєм",
  "screens.autostart":      "Автозапуск при завантаженні",
  "screens.autostartHint":  "Додаток запускається автоматично після перезавантаження",
  "screens.volume":         "Гучність",
  "screens.volumeSet":      "Встановити",
  "screens.wakeScreen":     "Увімкнути екран",
  "screens.screenOff":      "Вимкнути екран",
  "screens.restartApp":     "Перезапустити додаток",
  "screens.rebootDevice":   "Перезавантажити пристрій",
  "screens.syncNtp":        "Синхрон часу",
  "screens.apkUpdate":      "Оновлення ПЗ",
  "screens.downloadUpdate": "Скачати останнє",
  "screens.downloadApk":    "Завантажити APK",
  "screens.installSilent":  "Встановити тихо",
  "screens.installLoud":    "Встановити з діалогом",
  "screens.fetchingVer":    "Отримання версії…",

  // ── Медіатека ────────────────────────────────────────
  "nav.media":              "Медіа",
  "nav.playlists":          "Плейлисти",
  "nav.playlists2":         "Playlist 2",

  // ── Плейлисти ─────────────────────────────────────────
  "playlists.title":        "Плейлисти",
  "playlists.new":          "Новий плейлист",
  "playlists.newName":      "Новий плейлист",
  "playlists.namePlaceholder": "Назва плейлиста…",
  "playlists.empty":        "Плейлистів ще немає",
  "playlists.emptyHint":    "Натисніть «Новий плейлист», щоб розпочати",
  "playlists.saved":        "Збережено",
  "playlists.deleteTitle":  "Видалити плейлист?",
  "playlists.deleteHint":   "Плейлист та всі його елементи буде видалено назавжди.",
  "playlists.colName":      "Назва",
  "playlists.colItems":     "Елементи",
  "playlists.colDuration":  "Тривалість",
  "playlists.colUpdated":   "Оновлено",
  "playlists.description":  "Опис",
  "playlists.descPlaceholder": "Необов'язковий опис…",
  "playlists.transition":   "Перехід",
  "playlists.tr_cut":       "Різкий",
  "playlists.tr_fade":      "Плавний",
  "playlists.tr_slide":     "Зсув",
  "playlists.trDuration":   "Тривалість",
  "playlists.playback":     "Відтворення",
  "playlists.noBlackGap":   "Без чорного кадру",
  "playlists.random":       "Випадковий порядок",
  "playlists.syncEnabled":  "Синхронізація пристроїв",
  "playlists.duplicate":    "Дублювати",
  "playlists.queue":        "Черга",
  "playlists.queueEmpty":   "Додайте файли з бібліотеки нижче",
  "playlists.library":      "Медіабібліотека",
  "playlists.noMedia":      "Медіафайли ще не завантажені",
  "playlists.dblClickToAdd": "дв. клік — додати",
  "playlists.dragToInsert":  "тягни — вставити",
  "playlists.noSelected":    "Оберіть плейліст",
  "playlists.queueEmptyHint": "Перетягніть файли сюди",
  "playlists.settingsTab":   "Налаштування",
  "playlists.shuffle":       "Перемішати",
  "playlists.clearAll":      "Очистити",
  "playlists.addMedia":      "Додати медіа",

  "media.newFolder":        "Нова папка",
  "media.allFiles":         "Всі файли",
  "media.folders":          "Папки",
  "media.noFolders":        "Папок немає",
  "media.storage":          "Сховище",
  "media.selectFile":       "Виберіть файл для перегляду",
  "media.searchPlaceholder":"Пошук файлів і папок…",
  "media.uploadFiles":      "Завантажити",
  "media.dropHere":         "Перетягніть файли для завантаження у",
  "media.noFiles":          "Файлів у цій папці немає",
  "media.uploadHint":       "Натисніть «Завантажити файли» або перетягніть файли сюди",
  "media.resolution":       "Розширення",
  "media.size":             "Розмір",
  "media.bitrate":          "Бітрейт",
  "media.codec":            "Кодек",
  "media.colorDepth":       "Колірна глибина",
  "media.colorDepthWarn":   "Може не відтворюватись на деяких пристроях",
  "media.duration":         "Тривалість",
  "media.format":           "Формат",
  "media.uploaded":         "Завантажено",
  "media.lastPlayed":       "Останній показ",
  "media.colName":          "Назва",
  "media.colStatus":        "Статус",
  "media.colSize":          "Розмір",
  "media.colResolution":    "Розширення",
  "media.colDuration":      "Тривалість",
  "media.colLastPlayed":    "Останній показ",
  "media.colCreatedAt":     "Дата додавання",
  "media.availPeriod":      "Період доступності",
  "media.scheduled":        "Розклад",
  "media.from":             "Від",
  "media.until":            "До",
  "media.addTimeRange":     "Додати діапазон",
  "media.statusActive":     "Активно",
  "media.statusExpired":    "Завершено",
  "media.statusNotStarted": "Не розпочато",
  "media.usedInTitle":      "Файл використовується",
  "media.usedInDesc":       "не можна видалити, поки він використовується в:",
  "media.usedInPlaylists":  "Плейлісти",
  "media.usedInScreens":    "Приставки (контент за замовчуванням)",
  "media.usedInSchedules": "Розклади",
  "media.usedInHint":       "Спочатку приберіть файл з усіх плейлістів і приставок.",
  "media.defaultContent":   "Контент за замовчуванням",
  "media.transcoding":      "Конвертація в процесі",
  "media.transcodingDesc":  "— файл зараз конвертується у 8-bit H.264. Зачекайте завершення перед видаленням.",
  "media.blockedCount":     "{{count}} файлів з вибраних не вдалося видалити",

  // ── Спільне ──────────────────────────────────────────
  "nav.schedules":                  "Розклади",
  "schedules.title":                "Розклади",
  "schedules.new":                  "Новий розклад",
  "schedules.duplicate":            "Дублювати",
  "schedules.empty":                "Розкладів ще немає. Створіть перший.",
  "schedules.allSchedules":         "Усі розклади",
  "schedules.newEvent":             "Новий запис",
  "schedules.saveNeedsRecord":    "Додайте запис перед збереженням",
  "schedules.editEvent":            "Редагувати запис",
  "schedules.newRecord":            "Новий запис",
  "schedules.editRecord":           "Редагувати запис",
  "schedules.starts":               "Початок",
  "schedules.ends":                 "Кінець",
  "schedules.dateTime":             "Дата та час",
  "schedules.dateLocked":           "Дата заблокована",
  "schedules.timesInTz":            "Час за {{tz}}",
  "schedules.startRequired":        "Вкажіть дату та час початку",
  "schedules.endRequired":          "Вкажіть час завершення",
  "schedules.endBeforeStart":       "Кінець має бути пізніше початку",
  "schedules.overlapError":         "Перетин з існуючим записом",
  "schedules.today":                "Сьогодні",
  "schedules.day":                  "День",
  "schedules.week":                 "Тиждень",
  "schedules.month":                "Місяць",
  "schedules.settings":             "Налаштування",
  "schedules.eventType":            "Тип події",
  "schedules.scheduleContent":      "Відтворити контент",
  "schedules.screenOff":            "Вимкнути екран",
  "schedules.content":              "Контент",
  "schedules.playlist":             "Плейліст",
  "schedules.eventStarts":          "Початок події",
  "schedules.eventEnds":            "Кінець події",
  "schedules.repeatOptions":        "Параметри повторення",
  "schedules.repeat":               "Повторення",
  "schedules.repeatEvery":          "Повторювати кожні",
  "schedules.doesNotRepeat":        "Не повторюється",
  "schedules.daily":                "Щодня (Пн-Нд)",
  "schedules.weekday":              "Щоден. (Пн-Пт)",
  "schedules.weekly":               "Щотижня ({{day}})",
  "schedules.monthly":              "Щомісяця ({{n}}-го числа)",
  "schedules.annually":             "Щороку ({{date}})",
  "schedules.custom":               "Власний",
  "schedules.forever":              "Назавжди",
  "schedules.customDate":           "До вказаної дати",
  "schedules.customOccurrences":    "Кількість повторень",
  "schedules.occurrences":          "разів",
  "schedules.timezone":             "Розклад виконується за місцевим часом екрана.",
  "schedules.weekdaySun": "Неділя",   "schedules.weekdayMon": "Понеділок","schedules.weekdayTue": "Вівторок",
  "schedules.weekdayWed": "Середа",   "schedules.weekdayThu": "Четвер",   "schedules.weekdayFri": "П'ятниця", "schedules.weekdaySat": "Субота",
  "schedules.monthJan": "Січень",   "schedules.monthFeb": "Лютий",    "schedules.monthMar": "Березень",
  "schedules.monthApr": "Квітень",  "schedules.monthMay": "Травень",   "schedules.monthJun": "Червень",
  "schedules.monthJul": "Липень",   "schedules.monthAug": "Серпень",   "schedules.monthSep": "Вересень",
  "schedules.monthOct": "Жовтень",  "schedules.monthNov": "Листопад",  "schedules.monthDec": "Грудень",
  "schedules.events":               "подій",
  "schedules.screens":              "екранів",
  "schedules.noPlaylist":           "Оберіть плейліст…",
  "schedules.deleteConfirm":        "Видалити цей розклад? Усі події будуть видалені.",

  "nav.logs":   "Логи",
  "logs.title":         "Логи пристроїв",
  "logs.allDevices":    "Всі пристрої",
  "logs.allLevels":     "Всі рівні",
  "logs.allCategories": "Всі категорії",
  "logs.device":        "Пристрій",
  "logs.level":         "Рівень",
  "logs.category":      "Категорія",
  "logs.message":       "Повідомлення",
  "logs.time":          "Час",
  "logs.autoRefresh":   "Авто-оновлення",
  "logs.clearAll":      "Очистити все",
  "logs.noLogs":        "Логів немає",
  "logs.tabDebug":      "Debug",
  "logs.tabPlayback":   "Відтворення",
  "logs.pbName":        "Назва",
  "logs.pbStatus":      "Статус",
  "logs.pbFile":        "Файл",
  "logs.pbPlaylist":    "Плейлист",
  "logs.pbDuration":    "Тривалість",

  "playlists.publishedToScreens": "Опубліковано на {{count}} екран(ах)",
  "schedules.publishedToScreens": "Опубліковано на {{count}} екран(ах)",

  "schedules.records":              "Записи",
  "schedules.noRecords":            "Немає записів у цьому періоді",
  "schedules.repeatOnce":           "Одноразово",
  "schedules.repeatDaily":          "Щодня",
  "schedules.repeatWeekday":        "По буднях",
  "schedules.repeatWeekly":         "Щотижня",
  "schedules.repeatMonthly":        "Щомісяця",
  "schedules.repeatAnnually":       "Щороку",
  "schedules.repeatEveryDays":      "Кожні {{count}} дн.",
  "schedules.repeatEveryWeeks":     "Кожні {{count}} тижн.",
  "schedules.repeatEveryMonths":    "Кожні {{count}} міс.",
  "schedules.repeatEveryYears":     "Кожні {{count}} р.",
  "schedules.repeatAt":             "о {{time}}",
  "schedules.repeatUntil":          "до {{date}}",
  "schedules.repeatTimes":          "{{count}} раз(ів)",
  "schedules.startsOn":             "з {{date}}",
  "schedules.nextRun":              "наступний: {{date}}",

  "screens.dangerZone":         "Небезпечна зона",
  "screens.deleteDevice":       "Видалити пристрій",
  "screens.deleteDeviceConfirm": "Видалити цей екран назавжди?",

  "screens.bulk.screenCount_one":   "{{count}} екран",
  "screens.bulk.screenCount_other": "{{count}} екрани(ів)",
  "screens.bulk.reloadConfig":      "Перезавантажити конфіг",
  "screens.bulk.reloadConfigTitle": "Перезавантажити конфіг на вибраних пристроях",
  "screens.bulk.syncFiles":         "Синхронізувати файли",
  "screens.bulk.syncFilesTitle":    "Синхронізувати файли на вибраних пристроях",
  "screens.bulk.bulkEdit":          "Масове редагування",
  "screens.bulk.clearSelection":    "Зняти виділення",
  "screens.bulk.modalTitle":        "Масове редагування",
  "screens.bulk.screensSelected":   "{{count}} екранів вибрано",
  "screens.bulk.defaultContent":    "Контент за замовчуванням",
  "screens.bulk.selectPlaylist":    "— оберіть плейліст —",
  "screens.bulk.scheduledContent":  "Контент за розкладом",
  "screens.bulk.selectSchedule":    "— оберіть розклад —",
  "screens.bulk.orientation":       "Орієнтація екрана",
  "screens.bulk.landscape":         "Горизонтально",
  "screens.bulk.portrait":          "Вертикально",
  "screens.bulk.revLandscape":      "Гор. (обернено)",
  "screens.bulk.revPortrait":       "Верт. (обернено)",
  "screens.bulk.contentRotation":   "Поворот контенту",
  "screens.bulk.autostart":         "Автозапуск при увімкненні",
  "screens.bulk.standby":           "Вимкнути сплячий режим",
  "screens.bulk.company":           "Компанія",
  "screens.bulk.selectCompany":     "Виберіть компанію…",
  "screens.bulk.enabled":           "Увімкнено",
  "screens.bulk.disabled":          "Вимкнено",
  "screens.bulk.fieldsWillChange_one":   "{{count}} поле буде змінено",
  "screens.bulk.fieldsWillChange_other": "{{count}} поля(ів) буде змінено",
  "screens.bulk.selectFields":      "Оберіть поля для зміни",
  "screens.bulk.cancel":            "Скасувати",
  "screens.bulk.applying":          "Застосовується…",
  "screens.bulk.apply_one":         "Застосувати до {{count}} екрана",
  "screens.bulk.apply_other":       "Застосувати до {{count}} екранів",
  "screens.deleting":            "Видалення…",

  "cmdQueue.title":       "Черга команд",
  "cmdQueue.screen":      "Екран",
  "cmdQueue.command":     "Команда",
  "cmdQueue.status":      "Статус",
  "cmdQueue.createdAt":   "Створено",
  "cmdQueue.empty":       "Немає очікуючих команд",
  "cmdQueue.refresh":     "Оновити",
  "cmdQueue.publish":     "Опублікувати всі",
  "cmdQueue.publishing":  "Публікація…",

  // ── Логін ────────────────────────────────────────
  "login.subtitle":            "Увійдіть до свого акаунту",
  "login.loginPlaceholder":    "Введіть логін",
  "login.emailPlaceholder":    "Введіть email",
  "login.passwordPlaceholder": "Введіть пароль",
  "login.error":               "Невірний логін або пароль",
  "login.signingIn":           "Вхід…",
  "login.signIn":              "Увійти",

  "common.save":    "Зберегти",
  "common.cancel":  "Скасувати",
  "common.delete":  "Видалити",
  "common.rename":    "Перейменувати",
  "common.duplicate": "Дублювати",
  "common.edit":    "Редагувати",
  "common.add":     "Додати",
  "common.search":  "Пошук…",
  "common.loading": "Завантаження…",
  "common.of":      "з",
  "common.hidden":  "приховано",
  "common.back":    "Назад",
  "common.close":   "Закрити",
  "common.yes":     "Так",
  "common.no":      "Ні",
  "common.more":    "ще",
  "common.collapse":"Згорнути",
  "common.noData":  "Немає даних",

  // ── Reports ──────────────────────────────────────────
  "nav.reports":                        "Звіти",
  "reports.title":                      "Звіти про відтворення",
  "reports.period.day":                 "День",
  "reports.period.week":                "Тиждень",
  "reports.period.month":               "Місяць",
  "reports.tabContent":                 "Контент",
  "reports.tabFiles":                   "Контент",
  "reports.tabPlayers":                 "Плеєри",
  "reports.search":                     "Пошук",
  "reports.searchPlayers":              "Пошук плеєрів…",
  "reports.searchContent":              "Пошук контенту…",
  "reports.selectedOf":                 "Вибрано {{n}} із {{total}} — цифри сумуються",
  "reports.selectedFooter":            "Вибрано: {{n}} із {{total}}",
  "reports.nothingSelected":            "Нічого не вибрано",
  "reports.summed":                     "сумарно",
  "reports.filesWord":                  "роликів",
  "reports.playersWord":                "плеєрів",
  "reports.playsWord":                  "показів",
  "reports.noData":                     "Немає даних за період",
  "reports.refresh":                    "Оновити",
  "reports.badgeDetail":               "деталі",
  "reports.kpiPlays":                   "Показів",
  "reports.kpiAirtime":                 "Ефірний час",
  "reports.kpiPlayers":                 "Плеєрів",
  "reports.kpiErrors":                  "Обірвано",
  "reports.kpiContent":                "Роликів",
  "reports.kpiStatus":                 "Статус",
  "reports.byDays":                     "Покази по днях",
  "reports.byHours":                    "Профіль по годинах · за період",
  "reports.byPlayers":                  "За плеєрами",
  "reports.videosByPlayer":            "Відео на цьому екрані",
  "reports.playersForContent":         "Відтворення по екранах",
  "reports.colPlayer":                  "Плеєр",
  "reports.colStatus":                  "Статус",
  "reports.colPlays":                   "Показів",
  "reports.colFirst":                   "Перший показ",
  "reports.colLast":                    "Останній показ",
  "reports.colClip":                   "Ролик",
  "reports.colDuration":               "Тривалість",
  "reports.colShare":                  "Частка",
  "reports.airtimeNote":                "Ефірний час рахується за номінальною тривалістю ролика, тому цифра відтворювана. Фактичний час — настінний і гуляє на секунду-дві, він лишається лише для діагностики.",
  "reports.viewReportFor":              "Переглянути звіт за",
  "reports.playerSingular":             "пристрій",
  "reports.reportTitle":                "Звіт",

  // ── Профіль ───────────────────────────────────────────
  "nav.profile":              "Профіль",
  "profile.personal":         "Особиста інформація",
  "profile.firstName":        "Ім'я",
  "profile.lastName":         "Прізвище",
  "profile.email":            "Електронна пошта",
  "profile.login":            "Логін",
  "profile.save":             "Зберегти зміни",
  "profile.saving":           "Збереження…",
  "profile.saved":            "Профіль збережено",
  "profile.saveError":        "Помилка збереження профілю",
  "profile.changePassword":   "Зміна пароля",
  "profile.currentPassword":  "Поточний пароль",
  "profile.newPassword":      "Новий пароль",
  "profile.confirmPassword":  "Підтвердіть новий пароль",
  "profile.changePasswordBtn":"Змінити пароль",
  "profile.pwdChanged":       "Пароль змінено",
  "profile.pwdError":         "Не вдалося змінити пароль",
  "profile.pwdMismatch":      "Паролі не співпадають",
  "profile.pwdTooShort":      "Пароль має бути не менше 4 символів",
  "profile.appearance":       "Зовнішній вигляд",
  "profile.language":         "Мова",
  "profile.theme":            "Тема",
  "profile.dark":             "Темна",
  "profile.light":            "Світла",

  "dashboard.playsToday":           "Показів сьогодні",
  "dashboard.playsWeek":            "Показів / 7 днів",
  "dashboard.attention":            "Потребує уваги",
  "dashboard.topFiles":             "Топ роликів сьогодні",
  "dashboard.noTally":              "немає даних",
  "dashboard.noTallyHint":          "Онлайн, але лічильник не надходив понад 2 години",
  "dashboard.gap":                  "пропуск",
  "logs.errorsWord":            "помилок",
  "logs.clearConfirm":          "Очистити всі логи пристроїв?",
  "logs.footer":                "{{n}} записів · {{errors}} помилок. Цифри відтворення — у розділі «Звіти».",
  "screens.detail.lastSync":        "Остання синхронізація",
  "screens.detail.neverSynced":     "не було",

  // ── Зона завантаження медіа ──────────────────────────
  "media.dropZoneMain": "Перетягніть файли сюди",
  "media.dropZoneHint": "або натисніть «Додати файл»",

  // ── Сторінка налаштувань ─────────────────────────────
  "settings.saved":              "Збережено",
  "settings.saving":             "Збереження...",
  "settings.mediaSection":       "Налаштування медіа",
  "settings.imageScaleDefault":  "Масштаб зображень за замовчуванням",
  "settings.videoScaleDefault":  "Масштаб відео за замовчуванням",
  "settings.transcode8bit":      "Перекодувати відео в 8-bit H.264 при завантаженні",
  "settings.transcode8bitHint":  "Конвертує відео у формат 8-bit H.264 — сумісний з усіма Android-пристроями",
  "settings.autoResize":         "Автоматично зменшувати зображення",
  "settings.comingSoon":         "Незабаром",
  "settings.autoResizeHint":     "Стискати зображення до вибраного розміру при завантаженні",
  "settings.timeSection":        "Налаштування часу",
  "settings.timezone":           "Часовий пояс",
  "settings.timezoneNow":        "Зараз у цьому поясі: {{time}}",
  "settings.dst":                "Перехід на літній час",
  "settings.dstAuto":            "Автоматично, за правилами поясу",
  "settings.dstOff":             "Вимкнено — зимовий час цілий рік",
  "settings.dstChanges":         "Найближчі переведення годинника",
  "settings.dstDisabled":        "Переведення вимкнено — час не змінюється протягом року.",
  "settings.dstNoChanges":       "У цьому поясі переведення годинника не застосовується.",
  "settings.dstForward":         "годинник вперед",
  "settings.dstBackward":        "годинник назад",
  "settings.timeNote":           "Розклади задаються у цьому поясі. Сервер зберігає час в UTC, а пристрої самі перераховують його у місцевий — тому подія «щодня о 10:00» лишається о 10:00 і після переведення годинника.",
  "settings.cacheSection":         "Налаштування кешу",
  "settings.defaultCacheTtl":      "Термін зберігання кешу за замовчуванням",
  "settings.defaultCacheTtlHint":  "Як довго пристрої зберігають медіафайли в кеші. Застосовується до нових екранів.",
  "settings.cacheTtlDays":         "днів",
  "settings.cacheTtlUnlimited":    "необмежено (зберігати завжди)",
  "settings.offlineSection":       "Офлайн-активність",
  "settings.offlineTimeoutDays":   "Максимальний офлайн-період",
  "settings.offlineTimeoutHint":   "Через стільки днів без інтернету на екрані з'явиться повідомлення 'Connection lost'. 0 = без обмежень. Застосовується до нових екранів; у існуючих зберігається своє значення.",
  "settings.offlineDays":          "днів",
  "settings.offlineUnlimited":     "без обмежень",
  "settings.heartbeatSection":   "Heartbeat пристроїв",
  "settings.hbActive":           "Активний режим (сек)",
  "settings.hbActiveHint":       "Інтервал поки портал активний",
  "settings.hbPassive":          "Пасивний режим (сек)",
  "settings.hbPassiveHint":      "Інтервал вночі / без активності",
  "settings.hbWindow":           "Час активного вікна (хв)",
  "settings.hbWindowHint":       "Після останнього запиту → пасивний режим",
  "settings.hbNote":             "Після збереження нові значення відправляться на всі пристрої автоматично при наступній активності в порталі.",

  // ── Конструктор плейліста ────────────────────────────
  "playlists.queueTitle":          "Плейліст ({{count}})",
  "playlists.sortAlpha":           "А→Я",
  "playlists.clearPlaylist":       "✕ Очистити",
  "playlists.loadTemplate":        "📋 Завантажити шаблон…",
  "playlists.filesCount":          "({{count}} файлів)",
  "playlists.saveAsTemplate":      "💾 Зберегти як шаблон",
  "playlists.templateNamePh":      "Назва шаблону",
  "playlists.emptyQueue":          "Плейліст порожній",
  "playlists.addFromRight":        "Додайте файли зі списку праворуч",
  "playlists.enterManually":       "Введіть файли вручну",
  "playlists.filesOnDevices":      "Файли на пристроях ({{count}})",
  "playlists.addAll":              "Всі",
  "playlists.addSelected":         "Додати {{count}} обраних",
  "playlists.clearSelection":      "Зняти",
  "playlists.multiSelectHint":     "Ctrl — вибір, Shift — діапазон",
  "playlists.smartGenerator":      "Генератор плейлістів",
  "common.up":                     "Вгору",
  "common.down":                   "Вниз",

  // ── Редактор плейліста 2 ─────────────────────────────
  "playlists2.groupName":      "Група {{n}}",
  "playlists2.groupPlaceholder": "Назва групи",
  "playlists2.inRotation":     "{{count}} в ротації",
  "playlists2.ungroup":        "Розгрупувати",
  "playlists2.pass":           "прохід {{n}}",
  "playlists2.selected":       "{{count}} вибрано",
  "playlists2.group":          "Згрупувати",
  "playlists2.groupTooltip":   "Одна позиція ефіру — файли грають по черзі, по одному за прохід",
  "playlists2.change":         "Змінити…",
  "playlists2.scaleName":      "Масштаб",
  "playlists2.durationName":   "Тривалість",
  "playlists2.secPlaceholder": "сек",
  "playlists2.apply":          "Застосувати",
  "playlists2.deselect":       "Зняти",
  "playlists2.occupied":       "{{pct}}% зайнято",
  "playlists2.countCol":       "Кіл-ть",
  "playlists2.autoMode":       "авто режим",
}
